import { universalFetch } from "./common";
import type { BuyerHomeGoal, SavingsDetails } from "../interfaces/mainProfile";

export const updateHomeGoal = async (payload: Partial<BuyerHomeGoal>) => {
  try {
    const response = await universalFetch("/homeGoal", "PUT", payload);

    return response;
  } catch (error) {
    console.error("Failed to updateHomeGoal", error);
    throw error;
  }
};

export const getSavingsDetails = async () => {
  try {
    const response = await universalFetch("/savings", "GET");

    return response as SavingsDetails;
  } catch (error) {
    console.error("Failed to getSavingsDetails", error);
    throw error;
  }
};
